import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, TextField, Button } from "@mui/material";
import { ReactNotifications, Store } from "react-notifications-component";
import axios from "axios";
import "./css/loginPage.css";

const Login = () => {
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({
    email: "",
    password: "",
  });
  const handleSubmit = async (e) => {
    if (e) {
      e.preventDefault();
    }
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/login`,
        {
          email: inputs.email,
          password: inputs.password,
        },
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );
      console.log(response);
      const setCookieHeader = response.headers.get("set-cookie");
      console.log("Set-Cookie Header:", setCookieHeader);

      if (response.data.message === "Login successful") {
        navigate("/");
        // Store.addNotification({
        //   title: "User login Successful",
        //   message: "",
        //   type: "success",
        //   insert: "top",
        //   container: "bottom-center",
        //   animationIn: ["animate__animated", "animate__fadeIn"],
        //   animationOut: ["animate__animated", "animate__fadeOut"],
        //   dismiss: {
        //     duration: 2000,
        //     onScreen: true,
        //   },
        // });
      }
    } catch (error) {
      if (error.response) {
        // The server responded with a status code other than 2xx
        console.error(error.response.data.message); // Error response from the server
        // Store.addNotification({
        //   title: error.response.data.message,
        //   message: "",
        //   type: "warning",
        //   insert: "top",
        //   container: "bottom-center",
        //   animationIn: ["animate__animated", "animate__fadeIn"],
        //   animationOut: ["animate__animated", "animate__fadeOut"],
        //   dismiss: {
        //     duration: 2000,
        //     onScreen: true,
        //   },
        // });
        console.error(error.response.status); // HTTP status code
        console.error(error.response.headers); // Response headers
      } else if (error.request) {
        // The request was made, but no response was received
        console.error(error.request);
      } else {
        // Something happened in setting up the request that triggered an error
        console.error("Error", error.message);
      }
    }
  };

  //handle input change
  const handleChange = (e) => {
    setInputs((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  return (
    <div className="pageContainer">
      <form onSubmit={handleSubmit} className="loginForm">
        <Box className="formBox">
          <Typography
            variant="h4"
            sx={{
              textTransform: "uppercase",
              color: "#444444",
              fontWeight: "bold",
            }}
            padding={3}
            textAlign="center"
          >
            Login
          </Typography>
          <TextField
            placeholder="Email"
            value={inputs.email}
            name="email"
            margin="normal"
            type={"email"}
            required
            onChange={handleChange}
          />
          <TextField
            placeholder="Password"
            value={inputs.password}
            name="password"
            margin="normal"
            type={"password"}
            required
            onChange={handleChange}
          />

          <Button
            type="submit"
            sx={{ borderRadius: 3, marginTop: 3, width: "60%" }}
            variant="contained"
            color="primary"
          >
            Submit
          </Button>
        </Box>
      </form>
    </div>
  );
};

export default Login;
